import { Component } from 'react';
import './index.css';
import Loader from './load';

async function delay(ms) {
  // return await for better async stack trace support in case of errors.
  return await new Promise((resolve) => setTimeout(resolve, ms));
}

export class MyComponent extends Component {
  state = {
    activeUsers: 0,
    fallCount: 0,
    timer: 0,
    loading: true,
    ws: null,
  };

  componentDidMount() {
    if (this.state.ws != null) return;
    this.state.ws = new WebSocket('wss://ws.inwalled.com/atlas/');
    this.state.ws.addEventListener('message', (event) => {
      //there are two events
      let eventJSON = JSON.parse(event.data);
      this.setState({
        activeUsers: parseInt(eventJSON.currentPlayers, 10) - 1,
        fallCount: parseInt(eventJSON.fallCount, 10),
        loading: false,
      });
    });
    this.timerRefresh();
  }

  timerRefresh = async () => {
    this.setState({
      timer: this.state.timer + 1,
    });
    await delay(1000);
    this.timerRefresh();
  };

  // Render method.
  render() {
    return (
      <section id='centerSection'>
        {this.state.loading ? (
          <Loader></Loader>
        ) : (
          <div>
            <section id='topText'>
              <h1> You are Atlas.</h1>
              <h2> You hold up the sky.</h2>
            </section>
            <div id='bottomText'>
              <p id='mainText'>
                {' '}
                If no one is on this page, the sky will fall.
              </p>
              <p id='mainText'>
                There {this.state.activeUsers == 1 ? 'is' : 'are'}{' '}
                <span id='online-user-label'>{this.state.activeUsers}</span>{' '}
                other user{this.state.activeUsers == 1 ? '' : 's'} online.
              </p>
              <p id='mainText'>
                The sky has fallen{' '}
                <span id='total-skyfall-label'>{this.state.fallCount}</span>{' '}
                times.
              </p>
              <p id='mainText'>
                You have been holding the sky for{' '}
                <span id='active-time-label'>
                  {this.state.timer} second{this.state.timer != 1 ? 's' : ''}
                </span>
                .
              </p>
            </div>
          </div>
        )}
      </section>
    );
  }
}
